import type { ValueOf } from 'type-fest';

export const YoutubeThumbnailSize = {
  MAX: 'maxresdefault',
  STANDARD: 'sddefault',
  MEDIUM: 'mqdefault',
  SMALL: 'default',
} as const;

export type YoutubeThumbnailSizeT = ValueOf<typeof YoutubeThumbnailSize>;
